import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App'
import './styles.css'

const POSTER_CACHE = 'streamradar-posters-v2'

if ('caches' in window) {
  caches.keys().then(keys => {
    keys
      .filter(key => key.startsWith('streamradar-posters') && key !== POSTER_CACHE)
      .forEach(key => caches.delete(key))
  }).catch(() => undefined)
}

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    updateSW(true)
  },
  onRegisteredSW(_url, registration) {
    registration?.update().catch(() => undefined)
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode><App /></StrictMode>
)
